export const isTechnicalErrorInfo = (
  obj: unknown
): obj is {
  detail?: string;
  class?: string;
  title?: string;
  [key: string]: unknown;
} => typeof obj === 'object' && obj !== null;
